import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';
import References from './pages/References';
import Contact from './pages/Contact';
import About from './pages/About';
import Forbidden from './pages/Forbidden';
import NotFound from './pages/NotFound';

// Metadata mapping based on exact scrape data and default rules
const metadataMap = {
  '/': {
    title: 'TIG svejser i Brande | Svejsning nær Silkeborg & Horsens | Få tilbud',
    description: 'Leder du efter en TIG svejser? Vi hjælper med svejsning nær Brande, Silkeborg & Horsens. Mange års brancheerfaring. Kontakt os i dag!',
  },
  '/om-os': {
    title: 'Om os | JC Svejseteknik',
    description: 'Om os Tekst på vej – kontakt os allerede nu Vi arbejder lige nu på at opdatere vores side med endnu mere information om vores ydelser inden for aluminiumssvejsning, TIG-svejsning, rør og procesanlæg.',
  },
  '/ydelser': {
    title: 'Ydelser - JC Svejseteknik',
    description: 'JC Svejseteknik leverer professionel TIG-svejsning, CO2/MIG-MAG-svejsning og industriservice til virksomheder og private. Fokus på kvalitet, præcision og hurtig service.',
  },
  '/ydelser/tig-svejsning': {
    title: 'Tig svejsning | JC Svejseteknik',
    description: 'TIG svejsning udført af professionel TIG svejser Specialiseret præcisionsarbejde til både private og virksomheder Når du har brug for et flot, stærkt og præcist resultat, er TIG svejsning en oplagt lø',
  },
  '/ydelser/svejsning-i-aluminium': {
    title: 'Svejsning i aluminium i Brande | Svejsning nær Silkeborg & Horsens',
    description: 'Har du brug for svejsning i aluminium? Vores team leverer præcisionsarbejde, rådgivning & gennemsigtige tilbud til både private & erhverv. Få et tilbud!',
  },
  '/ydelser/co2-mig-mag': {
    title: 'CO2 / MIG-MAG - JC Svejseteknik',
    description: 'Professionel CO2 og MIG-MAG svejsning til tykkere materialer, stålkonstruktioner og seriefremstilling. Få et gennemsigtigt tilbud i dag.',
  },
  '/ydelser/industriservice': {
    title: 'Industriservice - JC Svejseteknik',
    description: 'Professionel industriservice, serviceaftaler, akut hjælp og forebyggende vedligehold af procesanlæg og maskiner. Hurtig udrykning i hele landet.',
  },
  '/referencer': {
    title: 'Reference | JC Svejseteknik',
    description: 'Se flere af vores projekter og referencer her.',
  },
  '/kontakt': {
    title: 'Kontakt | JC Svejseteknik',
    description: 'Har du spørgsmål eller kommentarer? Kontakt os i dag for at høre mere om, hvad vi kan gøre for dig.',
  },
  '/403': {
    title: 'Adgang nægtet - JC Svejseteknik',
    description: 'Du har ikke tilladelse til at tilgå denne side.',
  },
  '/404': {
    title: 'Siden blev ikke fundet - JC Svejseteknik',
    description: 'Beklager, vi kunne ikke finde den side, du leder efter.',
  },
};

function MetaManager() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const meta = metadataMap[path] || {
      title: 'JC Svejseteknik',
      description: 'JC Svejseteknik leverer professionel TIG-svejsning, CO2/MIG-MAG-svejsning og industriservice.',
    };

    // Update document title
    document.title = meta.title;

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', meta.description);

    // Update Open Graph tags for premium SEO
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', meta.title);

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', meta.description);
  }, [location]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <MetaManager />
      <div className="flex min-h-screen flex-col bg-brand-dark text-brand-light antialiased">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/ydelser" element={<Navigate to="/ydelser/tig-svejsning" replace />} />
            <Route path="/ydelser/:slug" element={<ServiceDetail />} />
            <Route path="/referencer" element={<References />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
